export const IMMIGRATE_QUESTION_CREATE_REQUEST = 'immigrate-question/create-request'
export const IMMIGRATE_QUESTION_CREATE_SUCCESS = 'immigrate-question/create-success'
export const IMMIGRATE_QUESTION_CREATE_FAILED = 'immigrate-question/create-failed'
